module.exports = __webpack_public_path__ + "static/img/Success.05e8cf34.jpg";